"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { ChevronDown } from "lucide-react";
import { onAuthStateChanged, User } from "firebase/auth";
import { auth } from "@/lib/firebase";
export function SiteHeader() {
  const $ = _c(92);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isSportsOpen, setIsSportsOpen] = useState(false);
  const [user, setUser] = useState(null);
  const pathname = usePathname();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const unsubscribe = onAuthStateChanged(auth, currentUser => {
        setUser(currentUser);
      });
      return () => unsubscribe();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="/" aria-label="Home" className="inline-flex bg-center sm:w-[100px] sm:h-[40px] hover:opacity-100 transition-opacity cursor-pointer opacity-80 mix-blend-screen w-[80px] h-[32px] bg-[url('/drawables/mvplayer_logo_tiny.png')] bg-no-repeat bg-[length:90%] items-center justify-center" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `hover:text-[#B0D18B] transition-colors cursor-pointer text-xs font-medium font-geist bg-transparent border-0 ${pathname === "/get-started" ? "text-[#B0D18B]" : "text-[#C4C8BA]"}`;
  let t4;
  if ($[3] !== t3) {
    t4 = <Link href="/get-started" className={t3}>Get Started</Link>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `flex items-center gap-1 hover:text-[#B0D18B] transition-colors cursor-pointer text-xs font-medium font-geist bg-transparent border-0 ${pathname === "/badminton" || pathname === "/padel" || pathname === "/tennis" || pathname === "/pickleball" ? "text-[#B0D18B]" : "text-[#C4C8BA]"}`;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronDown className="w-3 h-3 transition-transform group-hover:rotate-180" />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5) {
    t7 = <button className={t5}>Sports{t6}</button>;
    $[6] = t5;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = `px-3 py-2 rounded-lg text-xs font-medium font-geist transition-colors hover:bg-[#E2E3D8]/10 text-center ${pathname === "/padel" ? "text-[#B0D18B]" : "text-[#C4C8BA]"}`;
  let t9;
  if ($[8] !== t8) {
    t9 = <Link href="/padel" className={t8}>Padel</Link>;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = `px-3 py-2 rounded-lg text-xs font-medium font-geist transition-colors hover:bg-[#E2E3D8]/10 text-center ${pathname === "/tennis" ? "text-[#B0D18B]" : "text-[#C4C8BA]"}`;
  let t11;
  if ($[10] !== t10) {
    t11 = <Link href="/tennis" className={t10}>Tennis</Link>;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = `px-3 py-2 rounded-lg text-xs font-medium font-geist transition-colors hover:bg-[#E2E3D8]/10 text-center ${pathname === "/badminton" ? "text-[#B0D18B]" : "text-[#C4C8BA]"}`;
  let t13;
  if ($[12] !== t12) {
    t13 = <Link href="/badminton" className={t12}>Badminton</Link>;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  const t14 = `px-3 py-2 rounded-lg text-xs font-medium font-geist transition-colors hover:bg-[#E2E3D8]/10 text-center ${pathname === "/pickleball" ? "text-[#B0D18B]" : "text-[#C4C8BA]"}`;
  let t15;
  if ($[14] !== t14) {
    t15 = <Link href="/pickleball" className={t14}>Pickleball</Link>;
    $[14] = t14;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t11 || $[17] !== t13 || $[18] !== t15 || $[19] !== t9) {
    t16 = <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 min-w-[120px]"><div className="bg-[#12140E]/95 border border-[#8E9285]/20 rounded-xl p-2 shadow-xl backdrop-blur-xl flex flex-col gap-1">{t9}{t11}{t13}{t15}</div></div>;
    $[16] = t11;
    $[17] = t13;
    $[18] = t15;
    $[19] = t9;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== t16 || $[22] !== t7) {
    t17 = <div className="relative group">{t7}{t16}</div>;
    $[21] = t16;
    $[22] = t7;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  const t18 = `hover:text-[#B0D18B] transition-colors cursor-pointer text-xs font-medium font-geist bg-transparent border-0 ${pathname === "/faq" ? "text-[#B0D18B]" : "text-[#C4C8BA]"}`;
  let t19;
  if ($[24] !== t18) {
    t19 = <Link href="/faq" className={t18}>FAQ</Link>;
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  const t20 = `hover:text-[#B0D18B] transition-colors cursor-pointer text-xs font-medium font-geist bg-transparent border-0 ${pathname === "/store" ? "text-[#B0D18B]" : "text-[#C4C8BA]"}`;
  let t21;
  if ($[26] !== t20) {
    t21 = <Link href="/store" className={t20}>Store</Link>;
    $[26] = t20;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  let t22;
  if ($[28] !== t17 || $[29] !== t19 || $[30] !== t21 || $[31] !== t4) {
    t22 = <nav className="hidden md:flex items-center gap-4 lg:gap-6 mx-6 lg:mx-8">{t4}{t17}{t19}{t21}</nav>;
    $[28] = t17;
    $[29] = t19;
    $[30] = t21;
    $[31] = t4;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== pathname || $[34] !== user) {
    t23 = <div className="hidden md:flex items-center gap-2">{user ? <div className="relative group"><button className="inline-flex gap-1.5 lg:px-4 shadow-black/25 hover:bg-[#BFCBAD] transition-all cursor-pointer text-xs font-medium text-[#1E3702] font-geist bg-[#B0D18B] rounded-full pt-1.5 pr-3 pb-1.5 pl-3 shadow-lg gap-x-1.5 gap-y-1.5 items-center"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" style={{
            color: "rgb(30, 55, 2)",
            width: "16px",
            height: "16px"
          }} className="lucide lucide-zap w-[16px] h-[16px]" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><path fill="#1e3702" d="M14.945 1.25c-1.367 0-2.47 0-3.337.117c-.9.12-1.658.38-2.26.981c-.524.525-.79 1.17-.929 1.928c-.135.737-.161 1.638-.167 2.72a.75.75 0 0 0 1.5.008c.006-1.093.034-1.868.142-2.457c.105-.566.272-.895.515-1.138c.277-.277.666-.457 1.4-.556c.755-.101 1.756-.103 3.191-.103h1c1.436 0 2.437.002 3.192.103c.734.099 1.122.28 1.4.556c.276.277.456.665.555 1.4c.102.754.103 1.756.103 3.191v8c0 1.435-.001 2.436-.103 3.192c-.099.734-.279 1.122-.556 1.399s-.665.457-1.399.556c-.755.101-1.756.103-3.192.103h-1c-1.435 0-2.436-.002-3.192-.103c-.733-.099-1.122-.28-1.399-.556c-.243-.244-.41-.572-.515-1.138c-.108-.589-.136-1.364-.142-2.457a.75.75 0 1 0-1.5.008c.006 1.082.032 1.983.167 2.72c.14.758.405 1.403.93 1.928c.601.602 1.36.86 2.26.982c.866.116 1.969.116 3.336.116h1.11c1.368 0 2.47 0 3.337-.116c.9-.122 1.658-.38 2.26-.982s.86-1.36.982-2.26c.116-.867.116-1.97.116-3.337v-8.11c0-1.367 0-2.47-.116-3.337c-.121-.9-.38-1.658-.982-2.26s-1.36-.86-2.26-.981c-.867-.117-1.97-.117-3.337-.117z" /><path fill="#1e3702" d="M2.001 11.249a.75.75 0 0 0 0 1.5h11.973l-1.961 1.68a.75.75 0 1 0 .976 1.14l3.5-3a.75.75 0 0 0 0-1.14l-3.5-3a.75.75 0 0 0-.976 1.14l1.96 1.68z" /></svg>Account<ChevronDown className="w-3 h-3 ml-0.5 transition-transform group-hover:rotate-180" /></button><div className="absolute top-full right-0 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 min-w-[140px]"><div className="bg-[#12140E]/95 border border-[#8E9285]/20 rounded-xl p-2 shadow-xl backdrop-blur-xl flex flex-col gap-1"><Link href="/scores" className={`px-3 py-2 rounded-lg text-xs font-medium font-geist transition-colors hover:bg-[#E2E3D8]/10 text-center ${pathname === "/scores" ? "text-[#B0D18B]" : "text-[#C4C8BA]"}`}>Scores</Link><Link href="/feedback" className={`px-3 py-2 rounded-lg text-xs font-medium font-geist transition-colors hover:bg-[#E2E3D8]/10 text-center ${pathname === "/feedback" ? "text-[#B0D18B]" : "text-[#C4C8BA]"}`}>Feedback</Link><Link href="/account" className={`px-3 py-2 rounded-lg text-xs font-medium font-geist transition-colors hover:bg-[#E2E3D8]/10 text-center ${pathname === "/account" ? "text-[#B0D18B]" : "text-[#C4C8BA]"}`}>Account</Link></div></div></div> : <Link href="/account" className="inline-flex gap-1.5 lg:px-4 shadow-black/25 hover:bg-[#BFCBAD] transition-all cursor-pointer text-xs font-medium text-[#1E3702] font-geist bg-[#B0D18B] rounded-full pt-1.5 pr-3 pb-1.5 pl-3 shadow-lg gap-x-1.5 gap-y-1.5 items-center"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" style={{
          color: "rgb(30, 55, 2)",
          width: "16px",
          height: "16px"
        }} className="lucide lucide-zap w-[16px] h-[16px]" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><path fill="#1e3702" d="M14.945 1.25c-1.367 0-2.47 0-3.337.117c-.9.12-1.658.38-2.26.981c-.524.525-.79 1.17-.929 1.928c-.135.737-.161 1.638-.167 2.72a.75.75 0 0 0 1.5.008c.006-1.093.034-1.868.142-2.457c.105-.566.272-.895.515-1.138c.277-.277.666-.457 1.4-.556c.755-.101 1.756-.103 3.191-.103h1c1.436 0 2.437.002 3.192.103c.734.099 1.122.28 1.4.556c.276.277.456.665.555 1.4c.102.754.103 1.756.103 3.191v8c0 1.435-.001 2.436-.103 3.192c-.099.734-.279 1.122-.556 1.399s-.665.457-1.399.556c-.755.101-1.756.103-3.192.103h-1c-1.435 0-2.436-.002-3.192-.103c-.733-.099-1.122-.28-1.399-.556c-.243-.244-.41-.572-.515-1.138c-.108-.589-.136-1.364-.142-2.457a.75.75 0 1 0-1.5.008c.006 1.082.032 1.983.167 2.72c.14.758.405 1.403.93 1.928c.601.602 1.36.86 2.26.982c.866.116 1.969.116 3.336.116h1.11c1.368 0 2.47 0 3.337-.116c.9-.122 1.658-.38 2.26-.982s.86-1.36.982-2.26c.116-.867.116-1.97.116-3.337v-8.11c0-1.367 0-2.47-.116-3.337c-.121-.9-.38-1.658-.982-2.26s-1.36-.86-2.26-.981c-.867-.117-1.97-.117-3.337-.117z" /><path fill="#1e3702" d="M2.001 11.249a.75.75 0 0 0 0 1.5h11.973l-1.961 1.68a.75.75 0 1 0 .976 1.14l3.5-3a.75.75 0 0 0 0-1.14l-3.5-3a.75.75 0 0 0-.976 1.14l1.96 1.68z" /></svg>Account</Link>}</div>;
    $[33] = pathname;
    $[34] = user;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== isMobileNavOpen) {
    t24 = () => setIsMobileNavOpen(!isMobileNavOpen);
    $[36] = isMobileNavOpen;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-menu"><line x1="4" x2="20" y1="6" y2="6" /><line x1="4" x2="20" y1="12" y2="12" /><line x1="4" x2="20" y1="18" y2="18" /></svg>;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] !== t24) {
    t26 = <button id="menuBtn" aria-label="Toggle mobile menu" onClick={t24} className="md:hidden inline-flex items-center justify-center rounded-full p-1.5 text-[#E2E3D8] hover:bg-[#E2E3D8]/10 transition">{t25}</button>;
    $[39] = t24;
    $[40] = t26;
  } else {
    t26 = $[40];
  }
  let t27;
  if ($[41] !== t22 || $[42] !== t23 || $[43] !== t26) {
    t27 = <div className="shadow-black/20 bg-[#12140E]/80 w-fit border-[#8E9285]/20 border rounded-full mr-auto ml-auto shadow-2xl backdrop-blur-xl"><div className="flex sm:h-12 sm:pr-3 h-10 pr-2 pl-1 items-center justify-between">{t2}{t22}{t23}{t26}</div></div>;
    $[41] = t22;
    $[42] = t23;
    $[43] = t26;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  const t28 = `${isMobileNavOpen ? "" : "hidden"} md:hidden absolute top-16 left-0 right-0 z-50 flex justify-center`;
  let t29;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Link href="/get-started" className="text-left rounded-lg px-3 py-2 text-sm font-medium text-[#E2E3D8] hover:bg-[#E2E3D8]/10 transition-colors font-geist bg-transparent border-0" onClick={() => setIsMobileNavOpen(false)}>Get Started</Link>;
    $[45] = t29;
  } else {
    t29 = $[45];
  }
  let t30;
  if ($[46] !== isSportsOpen) {
    t30 = () => setIsSportsOpen(!isSportsOpen);
    $[46] = isSportsOpen;
    $[47] = t30;
  } else {
    t30 = $[47];
  }
  const t31 = `w-4 h-4 transition-transform ${isSportsOpen ? "rotate-180" : ""}`;
  let t32;
  if ($[48] !== t31) {
    t32 = <ChevronDown className={t31} />;
    $[48] = t31;
    $[49] = t32;
  } else {
    t32 = $[49];
  }
  let t33;
  if ($[50] !== t30 || $[51] !== t32) {
    t33 = <button onClick={t30} className="flex items-center justify-between w-full text-left rounded-lg px-3 py-2 text-sm font-medium text-[#E2E3D8] hover:bg-[#E2E3D8]/10 transition-colors font-geist bg-transparent border-0">Sports{t32}</button>;
    $[50] = t30;
    $[51] = t32;
    $[52] = t33;
  } else {
    t33 = $[52];
  }
  const t34 = `${isSportsOpen ? "flex" : "hidden"} flex-col gap-1 pl-4`;
  let t35;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <Link href="/padel" className="text-left rounded-lg px-3 py-2 text-sm font-medium text-[#E2E3D8] hover:bg-[#E2E3D8]/10 transition-colors font-geist bg-transparent border-0" onClick={() => setIsMobileNavOpen(false)}>Padel</Link>;
    $[53] = t35;
  } else {
    t35 = $[53];
  }
  let t36;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <Link href="/tennis" className="text-left rounded-lg px-3 py-2 text-sm font-medium text-[#E2E3D8] hover:bg-[#E2E3D8]/10 transition-colors font-geist bg-transparent border-0" onClick={() => setIsMobileNavOpen(false)}>Tennis</Link>;
    $[54] = t36;
  } else {
    t36 = $[54];
  }
  let t37;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <Link href="/badminton" className="text-left rounded-lg px-3 py-2 text-sm font-medium text-[#E2E3D8] hover:bg-[#E2E3D8]/10 transition-colors font-geist bg-transparent border-0" onClick={() => setIsMobileNavOpen(false)}>Badminton</Link>;
    $[55] = t37;
  } else {
    t37 = $[55];
  }
  let t38;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <Link href="/pickleball" className="text-left rounded-lg px-3 py-2 text-sm font-medium text-[#E2E3D8] hover:bg-[#E2E3D8]/10 transition-colors font-geist bg-transparent border-0" onClick={() => setIsMobileNavOpen(false)}>Pickleball</Link>;
    $[56] = t38;
  } else {
    t38 = $[56];
  }
  let t39;
  if ($[57] !== t34) {
    t39 = <div className={t34}>{t35}{t36}{t37}{t38}</div>;
    $[57] = t34;
    $[58] = t39;
  } else {
    t39 = $[58];
  }
  let t40;
  if ($[59] !== t33 || $[60] !== t39) {
    t40 = <div className="flex flex-col">{t33}{t39}</div>;
    $[59] = t33;
    $[60] = t39;
    $[61] = t40;
  } else {
    t40 = $[61];
  }
  let t41;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <Link href="/faq" className="text-left rounded-lg px-3 py-2 text-sm font-medium text-[#E2E3D8] hover:bg-[#E2E3D8]/10 transition-colors font-geist bg-transparent border-0" onClick={() => setIsMobileNavOpen(false)}>FAQ</Link>;
    $[62] = t41;
  } else {
    t41 = $[62];
  }
  let t42;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <Link href="/store" className="text-left rounded-lg px-3 py-2 text-sm font-medium text-[#E2E3D8] hover:bg-[#E2E3D8]/10 transition-colors font-geist bg-transparent border-0" onClick={() => setIsMobileNavOpen(false)}>Store</Link>;
    $[63] = t42;
  } else {
    t42 = $[63];
  }
  let t43;
  if ($[64] !== user) {
    t43 = user && <><Link href="/scores" className="w-full inline-flex items-center justify-center gap-2 rounded-lg mb-2 bg-[#B0D18B] px-3 py-2 text-sm font-medium text-[#1E3702] hover:bg-[#BFCBAD] transition-all font-geist" onClick={() => setIsMobileNavOpen(false)}>Scores</Link><Link href="/feedback" className="w-full inline-flex items-center justify-center gap-2 rounded-lg mb-2 bg-[#B0D18B] px-3 py-2 text-sm font-medium text-[#1E3702] hover:bg-[#BFCBAD] transition-all font-geist" onClick={() => setIsMobileNavOpen(false)}>Feedback</Link></>;
    $[64] = user;
    $[65] = t43;
  } else {
    t43 = $[65];
  }
  const t44 = `w-full inline-flex items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-all font-geist ${user ? "bg-[#12140E] border border-[#8E9285]/20 text-[#E2E3D8] hover:bg-[#E2E3D8]/10" : "bg-[#B0D18B] text-[#1E3702] hover:bg-[#BFCBAD]"}`;
  let t45;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = () => setIsMobileNavOpen(false);
    $[66] = t45;
  } else {
    t45 = $[66];
  }
  const t46 = user ? "currentColor" : "rgb(30, 55, 2)";
  let t47;
  if ($[67] !== t46) {
    t47 = {
      color: t46,
      width: "16px",
      height: "16px"
    };
    $[67] = t46;
    $[68] = t47;
  } else {
    t47 = $[68];
  }
  const t48 = user ? "none" : "#1e3702";
  let t49;
  if ($[69] !== t48) {
    t49 = <path fill={t48} d="M14.945 1.25c-1.367 0-2.47 0-3.337.117c-.9.12-1.658.38-2.26.981c-.524.525-.79 1.17-.929 1.928c-.135.737-.161 1.638-.167 2.72a.75.75 0 0 0 1.5.008c.006-1.093.034-1.868.142-2.457c.105-.566.272-.895.515-1.138c.277-.277.666-.457 1.4-.556c.755-.101 1.756-.103 3.191-.103h1c1.436 0 2.437.002 3.192.103c.734.099 1.122.28 1.4.556c.276.277.456.665.555 1.4c.102.754.103 1.756.103 3.191v8c0 1.435-.001 2.436-.103 3.192c-.099.734-.279 1.122-.556 1.399s-.665.457-1.399.556c-.755.101-1.756.103-3.192.103h-1c-1.435 0-2.436-.002-3.192-.103c-.733-.099-1.122-.28-1.399-.556c-.243-.244-.41-.572-.515-1.138c-.108-.589-.136-1.364-.142-2.457a.75.75 0 1 0-1.5.008c.006 1.082.032 1.983.167 2.72c.14.758.405 1.403.93 1.928c.601.602 1.36.86 2.26.982c.866.116 1.969.116 3.336.116h1.11c1.368 0 2.47 0 3.337-.116c.9-.122 1.658-.38 2.26-.982s.86-1.36.982-2.26c.116-.867.116-1.97.116-3.337v-8.11c0-1.367 0-2.47-.116-3.337c-.121-.9-.38-1.658-.982-2.26s-1.36-.86-2.26-.981c-.867-.117-1.97-.117-3.337-.117z" />;
    $[69] = t48;
    $[70] = t49;
  } else {
    t49 = $[70];
  }
  const t50 = user ? "none" : "#1e3702";
  let t51;
  if ($[71] !== t50) {
    t51 = <path fill={t50} d="M2.001 11.249a.75.75 0 0 0 0 1.5h11.973l-1.961 1.68a.75.75 0 1 0 .976 1.14l3.5-3a.75.75 0 0 0 0-1.14l-3.5-3a.75.75 0 0 0-.976 1.14l1.96 1.68z" />;
    $[71] = t50;
    $[72] = t51;
  } else {
    t51 = $[72];
  }
  let t52;
  if ($[73] !== t47 || $[74] !== t49 || $[75] !== t51) {
    t52 = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" style={t47} className="lucide lucide-zap w-[16px] h-[16px]" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">{t49}{t51}</svg>;
    $[73] = t47;
    $[74] = t49;
    $[75] = t51;
    $[76] = t52;
  } else {
    t52 = $[76];
  }
  let t53;
  if ($[77] !== t44 || $[78] !== t52) {
    t53 = <Link href="/account" className={t44} onClick={t45}>{t52}Account</Link>;
    $[77] = t44;
    $[78] = t52;
    $[79] = t53;
  } else {
    t53 = $[79];
  }
  let t54;
  if ($[80] !== t43 || $[81] !== t53) {
    t54 = <div className="mt-2 pt-2 border-t border-[#8E9285]/20">{t43}{t53}</div>;
    $[80] = t43;
    $[81] = t53;
    $[82] = t54;
  } else {
    t54 = $[82];
  }
  let t55;
  if ($[83] !== t40 || $[84] !== t54) {
    t55 = <div className="mx-auto w-fit rounded-2xl border border-[#8E9285]/20 bg-[#12140E]/95 backdrop-blur-xl shadow-2xl shadow-black/20"><nav className="flex flex-col gap-1 p-4 min-w-48">{t29}{t40}{t41}{t42}{t54}</nav></div>;
    $[83] = t40;
    $[84] = t54;
    $[85] = t55;
  } else {
    t55 = $[85];
  }
  let t56;
  if ($[86] !== t28 || $[87] !== t55) {
    t56 = <div id="mobileNav" className={t28}>{t55}</div>;
    $[86] = t28;
    $[87] = t55;
    $[88] = t56;
  } else {
    t56 = $[88];
  }
  let t57;
  if ($[89] !== t27 || $[90] !== t56) {
    t57 = <header className="fixed top-0 left-2 right-2 sm:left-4 sm:right-4 flex z-50 justify-center bg-background/60 backdrop-blur-md pt-2 sm:pt-4 rounded-b-2xl"><div className="min-h-fit lg:min-h-[175px] flex w-full max-w-7xl mr-auto ml-auto rounded-2xl items-start justify-center bg-background/60 backdrop-blur-md lg:bg-[url('/drawables/top_banner.webp')] lg:bg-cover lg:bg-center">{t27}{t56}</div></header>;
    $[89] = t27;
    $[90] = t56;
    $[91] = t57;
  } else {
    t57 = $[91];
  }
  return t57;
}